import React, {useState} from 'react'
import {Table, Avatar, Flex, Popconfirm, message} from 'antd'
import type {TableColumnsType} from 'antd'
import {useEmailContext} from '../../context/emailContext'
import {AccountType} from '../DataTypes/AccountsType'
import {DeleteFilled} from '@ant-design/icons'
import {DeleteAccountApi, GetAccountsApi} from '../../apicalls/ApiCall'
import {userId} from '../DataTypes/UserDataTypes'

const EmailAccountsTable = () => {
  const {accountData, setAccountIds, setAccountData} = useEmailContext()
  const [allSelected, setAllSelected] = useState<boolean>(false)
  const dataWithKeys = accountData.map((item, index) => ({
    ...item,
    key: item.id,
  }))
  const [messageApi, contextHolder] = message.useMessage()
  const columns: TableColumnsType<AccountType> = [
    {
      title: <span className='heading'>Email account</span>,
      dataIndex: 'name',
      render: (text: string) => <a>{text}</a>,
    },
    {
      title: <span className='heading'>Type</span>,
      dataIndex: 'type',
      render: (type) => (
        <Flex>
          {type === 'GMAIL' ? (
            <Flex align='center ' gap={'small'}>
              <img
                src={
                  'https://cdn1.iconfinder.com/data/icons/google-new-logos-1/32/gmail_new_logo-512.png'
                }
                alt='Gmail Icon'
                width={'20px'}
                height={'20px'}
              />
              <span>{type}</span>
            </Flex>
          ) : (
            <Flex align='center ' gap={'small'}>
              <img
                src={
                  'data:image/png;base64,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'
                }
                alt='Gmail Icon'
                width={'20px'}
                height={'20px'}
              />
              <span>{type}</span>
            </Flex>
          )}
        </Flex>
      ),
    },
    {
      title: (
        <span className='heading'>
          Action
          {allSelected ? (
            <DeleteFilled
              style={{background: 'white', cursor: 'pointer'}}
              className='text-dark text-hover-danger px-2'
              rev={undefined}
              onClick={() => console.log}
            />
          ) : (
            ''
          )}
        </span>
      ),
      width: 100,
      dataIndex: '',
      render: (text: string, record, index: number) => (
        <Popconfirm
          placement='left'
          title='Are you sure you want to delete this account?'
          onConfirm={() => handleAccountDelete(index)}
        >
          <Avatar
            shape='square'
            style={{background: 'white', cursor: 'pointer'}}
            className='text-dark text-hover-danger'
            icon={<DeleteFilled rev={undefined} />}
          />
        </Popconfirm>
      ),
    },
  ]

  // const rowSelection = {
  //   onChange: (selectedRowKeys: React.Key[], selectedRows: AccountType[]) => {
  //     console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows)
  //     if (selectedRows.length === accountData.length) {
  //       setAllSelected(true)
  //     } else {
  //       setAllSelected(false)
  //     }
  //   },
  //   getCheckboxProps: (record: AccountType) => ({
  //     disabled: record.name === 'Disabled User',
  //     name: record.name,
  //   }),
  // }
  const handleAccountDelete = async (index: number) => {
    try {
      let accountId = accountData[index].id
      let data = await DeleteAccountApi(userId, accountId)
      if (data) {
        setAccountIds(data)
        let values = await GetAccountsApi(userId)
        if (values) {
          if (values.success && values.data) {
            message.success('Email account deleted successfully')
            setAccountData(values.data)
          } else {
            message.error('Error deleting email account')
            console.error('Error while getting the accounts linked')
          }
        } else {
          message.error('Error deleting email account')
          console.error('Error while getting the accounts linked')
        }
      }
    } catch (err) {
      message.error('Error deleting email account ' + err)
      console.error('Error while deleting the account' + err)
    }
  }

  return (
    <div>
      {contextHolder}
      <Table size='small' columns={columns} dataSource={dataWithKeys} />
    </div>
  )
}

export default EmailAccountsTable
